import { MaskedLines, Overline, Reveal } from "./motion";

export const PageHeader = ({ id, overline, lines, sub }) => (
  <header className="mx-auto max-w-[1400px] px-6 pt-36 pb-16 md:px-12 md:pt-48 md:pb-24 lg:px-20">
    {overline && (
      <Reveal y={14}>
        <Overline data-testid={`${id}-overline`} className="mb-6">
          {overline}
        </Overline>
      </Reveal>
    )}
    <h1
      data-testid={`${id}-title`}
      className="font-serif text-5xl font-light leading-[1.02] tracking-tight text-[#1C1C1A] md:text-6xl lg:text-7xl"
    >
      <MaskedLines lines={lines} delay={0.1} />
    </h1>
    {sub && (
      <Reveal delay={0.45}>
        <p
          data-testid={`${id}-sub`}
          className="mt-8 max-w-xl text-base font-light leading-relaxed text-[#66625A] md:text-lg"
        >
          {sub}
        </p>
      </Reveal>
    )}
  </header>
);
